module.exports = __webpack_public_path__ + "img/disconnect.2e19bd47.svg";